import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import InputDefault from "../../components/Form/InputDefault";

import styles from './styles';


const EmailPix = () => {
    const [email, setEmail] = useState('');

    return (
        <>
            <HeaderDefault title={<FormattedMessage id='emailPix.email'/>} />

            <View style={styles.container}>
                <View style={styles.contentInput}>
                <FormattedMessage id='emailPix.placeholderEmail'>
                {placeholde =>
                    <InputDefault
                        value={email}
                        onValueChange={(value) => setEmail(value)}
                        placeholder={placeholder}
                    />}
                </FormattedMessage>
                </View>


                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='emailPix.valorTransferencia'/></Text>
                    <Text><FormattedMessage id='emailPix.valorTransferenciaBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='emailPix.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='emailPix.txtNome'/></Text>
                </View>
            </View>

            <Button route={<FormattedMessage id='emailPix.btnContinuar'/>} text={<FormattedMessage id='emailPix.txtContinuarTransferencia'/>} titlePage={"Confirmar tranferência"} />
        </>
    );
}

export default EmailPix;